<template>
  <div class="priceinput">
    <div class="priceinput-container ion-activatable" @click="openModal">
      <span class="label">{{ $utils.numberFormat(value) }}</span>
      <span class="symbol">K</span>
      <ion-icon :icon="caretDown"></ion-icon>
    </div>
  </div>
</template>


<style>
.priceinputmodal .modal-wrapper{
  --background: transparent;
}
</style>

<style lang="css" scoped>
.priceinput-container {
  min-width: 20.5vw;
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  border-radius: 8px;
  border:1px solid #aaa;
  padding: 1vw 2vw;
  align-items: center;
  cursor: pointer;
  font-size: 4vw;
}
.symbol {
  /*transform: scale(-1, -1);*/
  margin-left: 0.5vw;
}
</style>

<script>
  import {
    IonIcon,
    modalController,
  } from '@ionic/vue';
  import {
    caretDown,
  } from 'ionicons/icons';
  import { defineComponent, } from 'vue';
  import PriceInputModal from './PriceInputModal.vue';

  export default defineComponent({
    name: 'PriceInput',
    components: {
      IonIcon,
    },
    props: {
      value: [String, Number],
      title: {
        type: String,
        default: 'Chọn giá',
      },
      rtl: {
        type: Boolean,
        default: false,
      },
      iconSize: {
        type: String,
        default: 'small',
      },
      max: {
        type: Number,
        default: 2550,
      },
      min: {
        type: Number,
        default: 10,
      },
      errorMaxMsg: {
        type: String,
        default: 'Cược tối đa của mỗi thẻ là'
      },
      errorMinMsg: {
        type: String,
        default: 'Cược tối thiểu của mỗi thẻ là'
      }
    },
    data() {
      return {
        modalShowed: false,
      }
    },
    methods: {
      updateValue(newval) {
        this.$emit('change', newval);
      },
      async openModal() {
        const modal = await modalController
          .create({
            component: PriceInputModal,
            cssClass: 'priceinputmodal modal-fullscreen',
            componentProps: {
              title: this.title,
              value: this.value,
              rtl: this.rtl,
              iconSize: this.iconSize,
              max: this.max,
              min: this.min,
              errorMaxMsg: this.errorMaxMsg,
              errorMinMsg: this.errorMinMsg,
            },
          });
        modal.onWillDismiss().then((resp) => {
          if (resp.data && !resp.data.cancel) {
            this.updateValue(resp.data.value);
          }
        });

        return modal.present();
      },
    },
    setup() {
      return {
        caretDown,
      }
    }
  });
</script>
